import {Component, OnInit} from '@angular/core';
import {NgbModal,} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {TemplateService} from "../template.service";
import {TemplateDto} from "../../shipper";
import {CommonModule} from "@angular/common";
import {IsfFormComponent} from "../isf/isf.form";

@Component({
	selector: 'app-templates',
  	standalone: true,
	imports: [
		CommonModule
	],
  	templateUrl: './templates.component.html',
  	styleUrl: './templates.component.css'
})
export class TemplatesComponent implements OnInit{
	
	templates:Array<TemplateDto> = [];
	
	constructor(private service:TemplateService, private modal:NgbModal, private router:Router) {}
	
	ngOnInit(): void {
    	this.service.getTemplates().subscribe(t => this.templates = t);
    }
	
	
	isf(template:TemplateDto){
		let modal = this.modal.open(IsfFormComponent,{fullscreen: true, scrollable: true});
		modal.componentInstance.template = template;
		
		modal.componentInstance.onSubmit.subscribe(() => {
			modal.close();
			this.router.navigate(["isf"]);
		});
	}

}
